module.exports = __webpack_public_path__ + "img/button_bar_2.892b6bbb.svg";